import Image from "next/image";
import Link from "next/link";

export default function ProgramHero({ program, mentors }) {
  if (!program) {
    return null;
  }

  const isExternalLink = (url) => {
    return url && (url.startsWith("http://") || url.startsWith("https://"));
  };

  const renderSafeLink = (url, className, children) => {
    if (!url)
      return (
        <button className={className} disabled>
          {children}
        </button>
      );

    if (isExternalLink(url)) {
      return (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={className}
        >
          {children}
        </a>
      );
    }

    return (
      <Link href={url} className={className}>
        {children}
      </Link>
    );
  };
  
  const programMentors = mentors?.find(item => item.slug === program.slug);
  const mentorsArray = [];
  
  if (programMentors) {
    for (let i = 1; i <= 11; i++) {
      const nameKey = `mentor${i}name`;
      const imageKey = `mentor${i}image`;
      const postKey = `mentor${i}post`;
      
      if (programMentors[nameKey] && programMentors[imageKey] && programMentors[postKey]) {
        mentorsArray.push({
          name: programMentors[nameKey],
          image: programMentors[imageKey],
          position: programMentors[postKey]
        });
      }
    }
  }
  
  const visibleCount = 2;
  const additionalMentors = Math.max(0, mentorsArray.length - visibleCount);

  return (
    <div className="w-full flex items-center justify-center mx-auto py-10 md:py-16 mt-20">
      <div className="w-[90%] lg:[80%] md:w-[90%] text-white bg-[#142f2e] p-8 md:p-10 rounded-[24px]">
        <div className="hidden md:block">
          <div className="flex flex-col md:flex-row">
            <div className="md:w-[55%] pr-12">
              <div
                className="relative w-auto rounded-2xl overflow-hidden"
                style={{ height: "350px" }}
              >
                <Image
                  src={program.mainImage}
                  alt={program.heading}
                  fill
                  className="object-cover"
                  priority
                />
              </div>

              <div className="flex mt-6 gap-4">
                {renderSafeLink(
                  program.applyLink || "#",
                  "bg-[#33c375] hover:bg-[#54b556] text-[#002726] text-xl font-medium px-6 py-4 rounded-lg flex-1 text-center transition-colors",
                  "Join the Waitlist"
                )}

                {renderSafeLink(
                  program.brochureLink || "#",
                  "bg-[#fffaf1] hover:bg-gray-100 text-xl text-[#002726] font-medium px-6 py-4 rounded-lg flex-1 text-center transition-colors flex items-center justify-center",
                  <>
                   <Image
                  src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/dwar.svg"
                  alt="Brochure Icon"
                  width={20}
                  height={20}
                  className="mr-2"
                  priority
                />
                    Brochure
                  </>
                )}
              </div>
            </div>

            <div className="md:w-[45%] flex flex-col">
              <div>
                <h1 className="text-[28px] md:text-[40px] font-medium mb-4">
                  {program.heading}
                </h1>
                <p className="text-sm md:text-base font-normal mb-10">
                  {program.subheading}
                </p>

                <div className="mb-12">
                  <p className="text-gray-300 text-xs md:text-sm font-normal">
                    Cohort start date
                  </p>
                  <p className="text-base font-medium">{program.date}</p>
                </div>
              </div>

              {/* <div className="mt-auto">
                <p className="mb-4">Mentors</p>
                <div className="flex items-center flex-nowrap">
                  {mentorsArray.length > 0 ? (
                    <>
                      <div className="flex items-center">
                        {mentorsArray.slice(0, visibleCount).map((mentor, index) => (
                          <div key={index} className="flex items-center mr-6">
                            <div className="relative w-10 h-10 rounded-lg overflow-hidden border-2 border-[#1b3c3a] flex-shrink-0">
                              <Image
                                src={mentor.image}
                                alt={mentor.name}
                                fill
                                className="object-cover"
                              />
                            </div>
                            <div className="ml-3">
                              <p className="font-medium text-base truncate max-w-[120px]">{mentor.name}</p>
                              <p className="text-gray-300 text-sm">{mentor.position}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                      
                      {additionalMentors > 0 && (
                        <div className="text-white font-medium text-base">
                          + {additionalMentors} more
                        </div>
                      )}
                    </>
                  ) : (
                    program.mentorImage && (
                      <div className="flex items-center">
                        <div className="relative w-10 h-10 rounded-lg overflow-hidden border-2 border-[#1b3c3a] flex-shrink-0">
                          <Image
                            src={program.mentorImage}
                            alt={program.name}
                            fill
                            className="object-cover"
                          />
                        </div>
                        <div className="ml-3">
                          <p className="font-medium text-base truncate max-w-[120px]">
                            {program.name.includes("Multiple")
                              ? program.name.replace("Multiple mentors from", "")
                              : program.name}
                          </p>
                          <p className="text-gray-300 text-sm">{program.designation}</p>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div> */}
            </div>
          </div>
        </div>

        <div className="md:hidden">
          <div
            className="relative w-full rounded-2xl overflow-hidden mb-6"
            style={{ height: "170px" }}
          >
            <Image
              src={program.mainImage}
              alt={program.heading}
              fill
              className="object-cover"
              priority
            />
          </div>

          {/* <div className="mb-8">
            <p className="mb-3">Mentors</p>
            <div className="flex items-center">
              {mentorsArray.length > 0 ? (
                <>
                  <div className="flex items-center mr-3">
                    <div className="relative w-10 h-10 rounded-lg overflow-hidden border-2 border-[#1b3c3a] flex-shrink-0">
                      <Image
                        src={mentorsArray[0].image}
                        alt={mentorsArray[0].name}
                        fill
                        className="object-cover"
                      />
                    </div>
                    <div className="ml-2">
                      <p className="font-medium text-sm truncate max-w-[100px]">{mentorsArray[0].name}</p>
                      <p className="text-gray-300 text-xs truncate max-w-[100px]">{mentorsArray[0].position}</p>
                    </div>
                  </div>
                  
                  {mentorsArray.length > 1 && (
                    <div className="text-white font-medium text-sm">
                      + {mentorsArray.length - 1} more
                    </div>
                  )}
                </>
              ) : (
                program.mentorImage && (
                  <div className="flex items-center">
                    <div className="relative w-10 h-10 rounded-lg overflow-hidden border-2 border-[#1b3c3a] flex-shrink-0">
                      <Image
                        src={program.mentorImage}
                        alt={program.name}
                        fill
                        className="object-cover"
                      />
                    </div>
                    <div className="ml-2">
                      <p className="font-medium text-sm truncate max-w-[100px]">
                        {program.name.includes("Multiple")
                          ? program.name.replace("Multiple mentors from", "")
                          : program.name}
                      </p>
                      <p className="text-gray-300 text-xs truncate max-w-[100px]">{program.designation}</p>
                    </div>
                  </div>
                )
              )}
            </div>
          </div> */}

          <h1 className="text-[28px] font-medium mb-4">{program.heading}</h1>
          <p className="text-sm md:text-base mb-8">{program.subheading}</p>

          <div className="mb-8">
            <p className="text-gray-300 text-xs">Cohort start date</p>
            <p className="text-base font-medium">{program.date}</p>
          </div>

          <div className="flex flex-col gap-4 mt-6">
            {renderSafeLink(
              program.applyLink || "#",
              "bg-[#33c375] hover:bg-[#54b556] text-white text-base font-medium py-4 rounded-lg w-full text-center transition-colors",
              "Apply Now"
            )}

            {renderSafeLink(
              program.brochureLink || "#",
              "bg-white hover:bg-gray-100 text-[#142f2e] text-base font-medium py-4 rounded-lg w-full text-center transition-colors flex items-center justify-center",
              <>
                <Image
                  src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/dwar.svg"
                  alt="Brochure Icon"
                  width={20}
                  height={20}
                  className="mr-2"
                  priority
                />
                Brochure
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}